import {abilities} from './abilities';
import {authorizations} from './authorizations';
import {betaFlags} from './betaFlags';
import {branchMergeLocked} from './branchMergeLocked';
import {branches} from './branches';
import {cms} from './cms';
import {entitlements} from './entitlements';
import {featureFlags} from './featureFlags';
import {features} from './features';
import {hasSelectedInteractions} from './hasSelectedInteractions';
import {isEditingCodeComponent} from './isEditingCodeComponent';
import {isReadOnly} from './isReadOnly';
import {isUserComponentFocused} from './isUserComponentFocused';
import {localization} from './localization';
import {optimization} from './optimization';
import {hiddenPanels, visiblePanels} from './visiblePanels';
import {pageTypes} from './pageTypes';
import {permission} from './permission';
import {permissions} from './permissions';
import {publish} from './publish';
import {selectedElementOptimized} from './selectedElementOptimized';
import {hasUnrestrictedLocaleAccess} from './hasUnrestrictedLocaleAccess';
import {siteModes} from './siteModes';
import {siteKinds} from './siteKinds';
import {pageScope} from './pageScope';
import {userTypes} from './userTypes';
import {workflows} from './workflows';

export const validators = {
  abilities,
  authorizations,
  betaFlags,
  branchMergeLocked,
  branches,
  cms,
  entitlements,
  featureFlags,
  features,
  hasSelectedInteractions,
  hiddenPanels,
  isEditingCodeComponent,
  isReadOnly,
  isUserComponentFocused,
  localization,
  optimization,
  pageTypes,
  permission,
  permissions,
  publish,
  selectedElementOptimized,
  hasUnrestrictedLocaleAccess,
  siteModes,
  siteKinds,
  pageScope,
  userTypes,
  visiblePanels,
  workflows,
} as const;
